import React from 'react';

function UserTick(props: object) {
  return (
    <svg
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 15C18.4518 15 21.25 12.2018 21.25 8.75C21.25 5.29822 18.4518 2.5 15 2.5C11.5482 2.5 8.75 5.29822 8.75 8.75C8.75 12.2018 11.5482 15 15 15Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.26172 27.5C4.26172 22.6625 9.07421 18.75 14.9992 18.75C16.1992 18.75 17.3617 18.9125 18.4492 19.2125"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.5 22.5C27.5 23.4375 27.2375 24.325 26.775 25.075C26.5125 25.525 26.175 25.925 25.7875 26.25C24.9125 27.0375 23.7625 27.5 22.5 27.5C20.675 27.5 19.0875 26.525 18.225 25.075C17.7625 24.325 17.5 23.4375 17.5 22.5C17.5 20.925 18.225 19.5125 19.375 18.6C20.2375 17.9125 21.325 17.5 22.5 17.5C25.2625 17.5 27.5 19.7375 27.5 22.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.5508 22.4984L21.7883 23.7359L24.4508 21.2734"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default UserTick;
